/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Free_NameInputs */

const en_tier_free_name = /** @type {(inputs: Tier_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base Operator`)
};

const es_tier_free_name = /** @type {(inputs: Tier_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operador Base`)
};

const fr_tier_free_name = /** @type {(inputs: Tier_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opérateur de Base`)
};

const de_tier_free_name = /** @type {(inputs: Tier_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basis-Operator`)
};

const ja_tier_free_name = /** @type {(inputs: Tier_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベースオペレーター`)
};

const zh_tier_free_name = /** @type {(inputs: Tier_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基础操作者`)
};

const ar_tier_free_name = /** @type {(inputs: Tier_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مُشغل أساسي (Base Operator)`)
};

const id_tier_free_name = /** @type {(inputs: Tier_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operator Dasar`)
};

const it_tier_free_name = /** @type {(inputs: Tier_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operatore Base`)
};

const ru_tier_free_name = /** @type {(inputs: Tier_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Базовый Оператор`)
};

const pt_tier_free_name = /** @type {(inputs: Tier_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operador Base`)
};

const ko_tier_free_name = /** @type {(inputs: Tier_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`베이스 오퍼레이터 (Base Operator)`)
};

/**
* | output |
* | --- |
* | "Base Operator" |
*
* @param {Tier_Free_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_free_name = /** @type {((inputs?: Tier_Free_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Free_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_free_name(inputs)
	if (locale === "es") return es_tier_free_name(inputs)
	if (locale === "fr") return fr_tier_free_name(inputs)
	if (locale === "de") return de_tier_free_name(inputs)
	if (locale === "ja") return ja_tier_free_name(inputs)
	if (locale === "zh") return zh_tier_free_name(inputs)
	if (locale === "ar") return ar_tier_free_name(inputs)
	if (locale === "id") return id_tier_free_name(inputs)
	if (locale === "it") return it_tier_free_name(inputs)
	if (locale === "ru") return ru_tier_free_name(inputs)
	if (locale === "pt") return pt_tier_free_name(inputs)
	return ko_tier_free_name(inputs)
});